import firebase from '@/infra/firebase';
import Firebase from 'firebase/app';

export default {
  login() {
    return firebase.instance.auth.signInWithRedirect(
      new Firebase.auth.GoogleAuthProvider()
    );
  },
  logout() {
    firebase.instance.auth.signOut();
  },
  getCurrentUser(): Promise<Firebase.User | null> {
    return new Promise((resolve, reject) => {
      firebase.instance.auth.onAuthStateChanged(
        (user) => resolve(user),
        (err) => reject(err)
      );
    });
  },
};
